var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,29.1H6.3c-3.3,0-6-2.7-6-6v-17c0.2-3.4,2.8-6,6-6h10.3c3.3,0,6,2.7,6,6v17C22.6,26.4,20,29.1,16.6,29.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,48H6.3c-3.3,0-6-2.7-6-6v-4.5c0.2-3.4,2.8-6,6-6h10.3c3.3,0,6,2.7,6,6V42C22.6,45.3,20,48,16.6,48z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,48H31.3c-3.3,0-6-2.7-6-6V25.1c0-3.4,2.6-6,6-6h10.3c3.3,0,6,2.7,6,6V42C47.6,45.3,45,48,41.6,48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,16.6H31.3c-3.3,0-6-2.7-6-6V6.1c0-3.3,2.7-6,6-6h10.3c3.3,0,6,2.7,6,6v4.5C47.6,13.9,45,16.6,41.6,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardactive);
export default __webpack_public_path__ + "static/media/Dashboard active.fc7ed7a840c2258b6d2998583580a4c0.svg";
export { ForwardRef as ReactComponent };